import { formatNumber } from '@angular/common';

export class ByteSize {
	private _sizeInBytes: number;

	constructor(sizeInBytes: number) {
		this.sizeInBytes = sizeInBytes;
	}

	get sizeInBytes(): number {
		return this._sizeInBytes;
	}

	set sizeInBytes(value: number) {
		if (value === undefined) throw 'Please supply size in bytes.';
		this._sizeInBytes = value;
	}

	get sizeInKilobytes() {
		const adjustedValue = (this._sizeInBytes / 1024);
		return formatNumber(adjustedValue, 'en-US', '1.1-1');
	}

	get sizeInMegabytes() {
		const adjustedValue = (this._sizeInBytes / 1024 / 1024);
		return formatNumber(adjustedValue, 'en-US', '1.1-1');
	}

	get sizeInGigabytes() {
		const adjustedValue = (this._sizeInBytes / 1000 / 1000 / 1000);
		return formatNumber(adjustedValue, 'en-US', '1.1-1');
	}

	get sizeInGibibytes() {
		const adjustedValue = (this._sizeInBytes / 1024 / 1024 / 1024);
		return formatNumber(adjustedValue, 'en-US', '1.1-1');
	}

	get sizeInTerabytes() {
		const adjustedValue = (this._sizeInBytes / 1024 / 1024 / 1024 / 1024);
		return formatNumber(adjustedValue, 'en-US', '1.1-1');
	}
}
